import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postPayout } from 'services/UnifiedPayoutsService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { PayoutRequest } from 'types/unifiedPayouts/unifiedPayouts'

export const usePayoutsMutation = () => {
  return useMutation({
    mutationFn: postPayout,
    onError: (error: BaseErrorResponse, data: PayoutRequest) => {
      if (error?.status !== 428) {
        logSentryError('Error: usePayoutsMutation', error, data)
      }
    },
  })
}
